exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".margin-left-2[data-v-1fee5831]{margin-left:4px}.margin-left-2[data-v-1fee5831]:first-child{margin-left:0}", ""]);

// exports
